import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Fade out the flashing-logo splash once the app has mounted.
// Preview/sandbox: skip it entirely for faster testing. Live site: keep the intro.
(() => {
  const splash = document.getElementById("oce-splash");
  if (splash) {
    const host = window.location.hostname;
    const isPreview = host.includes("preview.emergentagent.com") || host === "localhost" || host === "127.0.0.1";
    if (isPreview) {
      splash.remove();
    } else {
      setTimeout(() => {
        splash.classList.add("hide");
        setTimeout(() => splash.remove(), 500);
      }, 1000);
    }
  }
  // Clear the app-icon badge bubble as soon as the app is opened / brought to the foreground.
  const clearBadge = () => { try { navigator.clearAppBadge && navigator.clearAppBadge(); } catch (_) {} };
  clearBadge();
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") clearBadge(); });
})();

// Register the PWA service worker (install + push). Safe no-op where unsupported.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
